import styled from "styled-components";

import { breakpoints, colors, fontFamily, spacing } from "../../../../theme";

export const Container = styled.footer`
  background-color: ${colors.grey.dark};
  color: ${colors.white};
  padding: ${spacing(8)} ${spacing(4)};
`;

export const Content = styled.div`
  display: block;
  @media only screen and (min-width: ${breakpoints.desktop}) {
    display: flex;
    /* justify-content: space-evenly;  Removed since only 2 columns for now*/
    gap: 10%;
    width: 90%;
    margin: 0 auto;
  }
`;

export const Column = styled.div``;

export const Avatar = styled.div``;

export const Name = styled.div`
  font-size: 20px;
  font-family: ${fontFamily.bold};
  margin-left: ${spacing(4)};
  width: 13ch;
`;

export const HelperText = styled.span`
  color: ${colors.grey.medium};
  font-family: ${fontFamily.regular};
  display: block;
  line-height: 140%;
  letter-spacing: 1%;

  &:first-of-type {
    margin-top: ${spacing(4)};
  }
`;

export const SocialLinks = styled.div`
  margin-top: ${spacing(10)};
`;

export const ColumnHeading = styled.h2`
  font-size: 20px;
  font-family: ${fontFamily.medium};
  margin: ${spacing(8)} 0 ${spacing(4)};
`;

export const LinkList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const LinkListItem = styled.li`
  margin: 0;
  padding: 0;
`;

export const BadgeColumn = styled(Column)`
  margin-top: ${spacing(8)};
`;
